import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { cn } from 'shared/util/cn'

function Modal({ open, onClose, children, className = '', title }) {
  useEffect(() => {
    if (!open) return undefined
    const onKey = (e) => {
      if (e.key === 'Escape') onClose?.()
    }
    window.addEventListener('keydown', onKey)
    return () => window.removeEventListener('keydown', onKey)
  }, [open, onClose])

  if (!open) return null

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center bg-dark/60 p-4 sm:items-center">
      <button type="button" className="absolute inset-0 cursor-pointer" aria-label="Close" onClick={onClose} />
      <div className={cn('relative z-10 w-full max-w-md rounded-card bg-surface p-5 shadow-card', className)}>
        {title && <h3 className="mb-3 text-3xl font-semibold text-ink">{title}</h3>}
        {children}
      </div>
    </div>
  )
}

Modal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
  title: PropTypes.string
}

export default Modal
